import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddTableCombinationInReservation1753163678333 implements MigrationInterface {
	name = 'AddTableCombinationInReservation1753163678333'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "reservation" ADD "tableCombinationId" uuid`)
		await queryRunner.query(
			`ALTER TABLE "reservation" ADD CONSTRAINT "FK_74e7d80db2404e8fba2f86f5ade" FOREIGN KEY ("tableCombinationId") REFERENCES "table_combination"("id") ON DELETE NO ACTION ON UPDATE NO ACTION`,
		)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "reservation" DROP CONSTRAINT "FK_74e7d80db2404e8fba2f86f5ade"`)
		await queryRunner.query(`ALTER TABLE "reservation" DROP COLUMN "tableCombinationId"`)
	}
}
